<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview" v-if="initData">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="initData.bd_pb_code">
            <label class="weui-form-preview__label">对账单号</label>
            <span class="weui-form-preview__value">{{initData.bd_pb_code}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.bd_pb_affirm_status">
            <label class="weui-form-preview__label">确认状态</label>
            <span class="weui-form-preview__value">{{initData.bd_pb_affirm_status}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pi_date}}</span>
          </div> -->
          <div class="weui-form-preview__item" v-if="initData.bd_source_type">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{bd_source_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来源单号</label>
            <span class="weui-form-preview__value">{{initData.bd_source_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库单号</label>
            <span class="weui-form-preview__value">{{initData.bd_pi_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">送货单号</label>
            <span class="weui-form-preview__value">{{initData.pi_sendcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库数量</label>
            <span class="weui-form-preview__value">{{initData.bd_pi_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.bd_pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.bd_source_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出入库金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.bd_pi_total}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币别</label>
            <span class="weui-form-preview__value">{{initData.bd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.bd_pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.bd_pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.bd_pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.bd_pr_brand}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  },
  data() {
    return {

    }
  },
  computed: {
    bd_source_type() {
      let obj = {
        PURCOUT: "采购退货",
        PURCIN: "采购入库",
        OSMAKEIN: "外协入库",
        OSMAKEINBACK: "外协退货"
      }
      return obj[this.initData.bd_source_type]
    }
  },
  methods: {

  },
};
</script>